import { tokenRedirectUri } from 'root/src/shared/constants/pageData';
import { authApiBase } from 'root/src/shared/constants/auth';
// TODO rename it? it's not oidc anymore
export const getOidcUrl = (provider, token, state = {}, redirectUrl = tokenRedirectUri) => {
    const stateJSON = JSON.stringify(Object.assign({ token, redirectUrl }, state));
    const stateEncoded = encodeURIComponent(stateJSON);
    return `${authApiBase}/sign-in/${provider}?state=${stateEncoded}`;
};
